import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI, Scrollbox} from '@colonist/pixi'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {GameColor} from '../../GameColor'
import {GameEndChartColumnData, UIGameEndChartColumnView} from './UIGameEndChartColumnView'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIGameEndChartView extends SectionBgView {
    private readonly parentContainer: PIXI.Container
    private readonly maxVisibleColumnCount = 11

    protected readonly spaceFromLeft: number
    protected readonly chartTitleHeight: number
    protected readonly chartColumnY: number
    protected readonly chartColumnHeight: number
    protected readonly chartColumnContainerWidth: number
    protected readonly chartColumnWidth: number
    protected readonly isHorizontallyScrollable: boolean
    protected readonly title: TextView
    protected readonly columnCornerRadius: number

    protected scrollBox: Scrollbox
    protected columnDataArray: GameEndChartColumnData[]

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, totalColumnCount: number, title: TranslationObject) {
        super(x, y, w, h, container)
        const visibleColumnCount = Math.min(totalColumnCount, this.maxVisibleColumnCount)

        const isUserOnMobileApp = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        this.parentContainer = container
        this.columnCornerRadius = this.width * 0.01
        this.columnDataArray = []

        this.spaceFromLeft = this.width / 15
        this.chartColumnContainerWidth = (this.width - 2 * this.spaceFromLeft) / visibleColumnCount
        this.chartColumnWidth = this.getChartColumnWidth(visibleColumnCount)

        this.chartTitleHeight = isUserOnMobileApp ? 0 : this.height / 15
        this.chartColumnY = isUserOnMobileApp ? this.height / 30 : this.chartTitleHeight * 1.1
        this.chartColumnHeight = isUserOnMobileApp ? this.height * 0.75 : this.height * 0.7

        if(isUserOnMobileApp) return
        this.title = new TextView(title, this.spaceFromLeft, 0, this.width, this.chartTitleHeight, this, GameFont.Size.L, GameColor.getColor(GameColor.Color.White))
        this.title.makeBold()
    }

    protected drawChart() {
        const largestYAxisNumber = this.columnDataArray.reduce((max, item) => Math.max(max, item.amount), 0)
        for(const [index, data] of this.columnDataArray.entries()) {
            const chartColumnX = this.spaceFromLeft + (index * this.chartColumnContainerWidth)
            new UIGameEndChartColumnView(chartColumnX, this.chartColumnY, this.chartColumnWidth, this.chartColumnHeight, this.columnCornerRadius, this, data, largestYAxisNumber)
        }
    }

    private getChartColumnWidth(visibleColumnCount: number): number {
        const maxColumnWidth = this.chartColumnContainerWidth * 0.8
        const minColumnWidth = this.chartColumnContainerWidth * 0.3

        const maxColumnWidthIncrease = maxColumnWidth - minColumnWidth
        const columnWidthIncreaseRatio = visibleColumnCount / this.maxVisibleColumnCount

        const columnWidthIncrease = maxColumnWidthIncrease * columnWidthIncreaseRatio
        const chartColumnWidth = minColumnWidth + columnWidthIncrease

        return chartColumnWidth
    }

    addEmptyColumn() {
        const mockData: GameEndChartColumnData = {label: {key: 'strings:colonistCommon.utils.emptyString'}, amount: 0, texture: undefined}
        const x = this.spaceFromLeft + (this.columnDataArray.length * this.chartColumnContainerWidth)
        new UIGameEndChartColumnView(x, this.chartColumnY, this.chartColumnWidth, this.chartColumnHeight, this.columnCornerRadius, this, mockData, 1)
    }

    show() {
        this.parentContainer.eventMode = 'auto'

        if(this.parent != undefined) return
        this.parentContainer.addChild(this)
    }

    hide() {
        this.parentContainer.eventMode = 'none'

        if(this.parent == undefined) return
        this.parentContainer.removeChild(this)
    }
}
